import { CircularProgress, Divider, Stack } from '@mui/material'
import { MetadataSkeleton } from '@cibo/landmanager'

export const LandReportSkeleton = () => (
  <Stack flex={1} spacing={3} divider={<Divider />}>
    <MetadataSkeleton />
    <Stack flex={1} justifyContent="center" alignItems="center">
      <CircularProgress size="large" color="primary" />
    </Stack>
  </Stack>
)
